import React from "react";
import {
  Card,
  Table,
  Tbody,
  Thead,
  Tr,
  Th,
  Td,
  Status,
  ButtonIcon,
  Pagination,
  FormInput,
  Button,
} from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faPen,
  faStream,
} from "@fortawesome/free-solid-svg-icons";

import ModalDetails from "./ModalDetails";
import ModalAnalyse from "./ModalAnalyse";

import handleSortClick from "../../utils/handleSortClickV2";
import { getValue } from "../../utils/general";

import AuthContext from "../../context/AuthContext";

const dataResp = [
  {
    name: "Pertinence des supports de communication",
    key: "radio-cabinet-pertinence",
  },
  {
    name: "Facilité de contact",
    key: "radio-cabinet-contact",
  },
  {
    name: "Réponses apportées",
    key: "radio-accueil-reponse",
  },
  {
    name: "Amabilité de l'interlocuteur",
    key: "radio-accueil-amabilite",
  },
  { name: "Délai d'attente", key: "radio-accueil-attente" },
  { name: "Qualité d'écoute", key: "radio-accueil-qualite" },
  {
    name: "Compréhension",
    key: "radio-accueil-comprehension",
  },
  {
    name: "Clarté / pertinence",
    key: "radio-gestion-information",
  },
  { name: "Délai de réponse", key: "radio-gestion-reponse" },
  { name: "Amabilité", key: "radio-gestion-amabilite" },
];

const getNoteValue = (key, isInt = false) => {
  if (isInt) {
    switch (key) {
      case 0:
        return "0";
      case 1:
        return "3";
      case 2:
        return "7";
      case 3:
        return "10";
      default:
        return "";
    }
  } else {
    switch (key) {
      case 0:
        return "Mauvais";
      case 1:
        return "Moyen";
      case 2:
        return "Bien";
      case 3:
        return "Très bien";
      default:
        return "";
    }
  }
};

export default class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalData: false,
      modalDataIdx: null,
      isModalAnalyse: false,
      modalAnalyseIdx: null,
      reference: "",
      isExport: false,
      exportRows: null,
    };
    this.sortRef = [];
  }

  static contextType = AuthContext;

  getColor = (value) => {
    if (value > 18) {
      return "bg-green-light";
    } else if (value < 10) {
      return "bg-red-light";
    } else {
      return "";
    }
  };

  handleSortClick = (desc, column) => {
    this.setState(
      { order: handleSortClick(this.sortRef, desc, column) },
      () => {
        this.props.handleSortClick(this.state.order);
      }
    );
  };

  getNPS = (nps) => {
    if (nps >= 9) {
      return (
        <Status
          className="bg-green-light black w-100 nowrap"
          text="Promoteur"
        />
      );
    } else if (nps >= 7) {
      return (
        <Status className="bg-orange-light black w-100 nowrap" text="Passif" />
      );
    } else if (nps >= 0 && nps !== null) {
      return (
        <Status className="bg-red-light black w-100 nowrap" text="Détracteur" />
      );
    } else {
      return null;
    }
  };

  getRows = () => this.state.exportRows || this.props.listData;

  calculateAverages = () => {
    const data = this.getRows();
    if (!data || data.length === 0) {
      return null;
    }

    let totals = {
      value: 0,
      nps: 0,
      valueCount: 0,
      npsCount: 0,
      npsDetracteur: 0,
      npsPassif: 0,
      npsPromoteur: 0,
      dataResp: {},
    };

    // Initialiser les totaux pour dataResp
    dataResp.forEach((item) => {
      totals.dataResp[item.key] = { sum: 0, count: 0 };
    });

    // Calculer les sommes
    data.forEach((row) => {
      // Moyenne pour la note (value)
      if (
        row.value !== null &&
        row.value !== undefined &&
        typeof row.value === "number"
      ) {
        totals.value += row.value;
        totals.valueCount++;
      }

      // Moyenne pour NPS et répartition
      if (
        row.nps !== null &&
        row.nps !== undefined &&
        typeof row.nps === "number"
      ) {
        totals.nps += row.nps;
        totals.npsCount++;

        // Compter la répartition NPS
        if (row.nps >= 9) {
          totals.npsPromoteur++;
        } else if (row.nps >= 7) {
          totals.npsPassif++;
        } else if (row.nps >= 0) {
          totals.npsDetracteur++;
        }
      }

      // Moyennes pour les réponses dataResp
      if (row.data) {
        dataResp.forEach((item) => {
          const value = getNoteValue(row.data[item.key], true);
          if (value !== "") {
            totals.dataResp[item.key].sum += parseInt(value);
            totals.dataResp[item.key].count++;
          }
        });
      }
    });

    // Calculer les pourcentages NPS selon la formule standard
    let npsRepartition = "";
    if (totals.npsCount > 0) {
      const pourcentageDetracteur =
        (totals.npsDetracteur / totals.npsCount) * 100;
      const pourcentagePromoteur =
        (totals.npsPromoteur / totals.npsCount) * 100;

      // NPS = % Promoteurs - % Détracteurs
      const npsScore = pourcentagePromoteur - pourcentageDetracteur;

      npsRepartition = getValue(npsScore);
    }

    // Calculer les moyennes
    const averages = {
      date: "MOYENNE",
      sinister: "",
      reference: "",
      region: "",
      agency: "",
      expert: "",
      assistant: "",
      comment: "",
      reparable: "",
      value:
        totals.valueCount > 0 ? getValue(totals.value / totals.valueCount) : "",
      nps: npsRepartition,
      analyse: "",
      data: {},
    };

    // Calculer les moyennes pour dataResp
    dataResp.forEach((item) => {
      const respData = totals.dataResp[item.key];
      if (respData.count > 0) {
        averages.data[item.key] = respData.sum / respData.count;
      } else {
        averages.data[item.key] = null;
      }
    });

    return averages;
  };

  render() {
    const tableHead = [
      { name: "Date", key: "date", isSort: true },
      {
        name: "N° de sinistre",
        key: "sinister",
        isSort: true,
      },
      {
        name: "Référence",
        key: "reference",
        isSort: true,
      },
      { name: "Région", key: "region", isSort: true },
      { name: "Agence", key: "agency", isSort: true },
      { name: "Expert", key: "expert", isSort: true },
      { name: "Assistant(e)", key: "assistant", isSort: true },
      {
        name: "Commentaire",
        key: "comment",
        isMultiLine: true,
        minWidth: "360px",
      },
      {
        name: "Réparable",
        key: "reparable",
      },
      {
        name: "Note",
        key: "value",
        format: (value) => (value ? getValue(value) : ""),
        isSort: true,
      },
      {
        name: "NPS",
        key: "nps",
        format: this.state.isExport
          ? (nps) => (nps || "").toString()
          : this.getNPS,
        isSort: true,
      },
      { name: "Analyse", key: "analyse", isMultiLine: true, minWidth: "360px" },
    ];

    return (
      <>
        <Card
          className={this.props.className}
          classNameChildren="overflow-x-auto"
          title="Liste des réponses"
          action={<FontAwesomeIcon icon={faStream} />}
          onClick={this.props.onListAll}
        >
          <div className="d-flex">
            <FormInput
              style={{ width: "200px" }}
              className={"mb-10"}
              placeholder="Référence"
              title="Référence"
              name="reference"
              value={this.state.reference}
              onChange={({ target }) =>
                this.setState({
                  reference: target.value,
                })
              }
            />
            <Button
              className="ml-10 mb-10 mt-auto w-auto"
              text="Rechercher"
              onClick={() => this.props.initSearch(this.state.reference)}
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </div>
          <Table
            isCSV
            getAllData={(callback) =>
              this.props.getAllRows((rows) =>
                this.setState({ isExport: true, exportRows: rows }, () =>
                  setTimeout(() => callback(), 2000)
                )
              )
            }
            csvCallback={() =>
              this.setState({ isExport: false, exportRows: null })
            }
          >
            <Thead>
              <Tr>
                {[
                  ...tableHead,
                  ...(this.state.isExport
                    ? dataResp.map((el) => ({ ...el, isExport: true }))
                    : []),
                ].map((element, idx) => (
                  <Th
                    className="pl-10 pr-10"
                    key={element.isExport ? `${idx}-print` : idx}
                    ref={
                      element.isExport
                        ? null
                        : (ref) => (this.sortRef[idx] = ref)
                    }
                    sort={element.isExport ? null : element.isSort}
                    onSort={
                      element.isExport || !element.isSort
                        ? null
                        : (desc) => this.handleSortClick(desc, idx)
                    }
                    nameSort={element.isExport ? null : element.key}
                  >
                    {element.name}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {(() => {
                console.log("ListData:", this.props.listData); // Debug log
                console.log("IsExport:", this.state.isExport); // Debug log
                const rows = this.getRows();
                if (!rows || rows.length === 0) {
                  console.log("No data to display"); // Debug log
                  return null;
                }
                return [
                  ...rows.map((element, idx) => (
                    <Tr key={idx}>
                      {[
                        ...tableHead,
                        ...(this.state.isExport
                          ? dataResp.map((el) => ({ ...el, isExport: true }))
                          : []),
                      ].map((elementBody, idxBody) => (
                        <Td
                          style={
                            elementBody.minWidth
                              ? { minWidth: elementBody.minWidth }
                              : {}
                          }
                          className={`pl-10 pr-10 ${
                            elementBody.isMultiLine ? "" : "nowrap"
                          } ${this.getColor(element.value)}`}
                          key={
                            elementBody.isExport
                              ? `${idx}-${idxBody}-${elementBody.key}`
                              : `${idx}-${idxBody}`
                          }
                        >
                          {elementBody.isExport
                            ? getNoteValue(
                                element.data[elementBody.key],
                                this.props.company === 16
                              )
                            : elementBody.format
                            ? elementBody.format(element[elementBody.key])
                            : element[elementBody.key]
                            ? element[elementBody.key].toString()
                            : ""}
                        </Td>
                      ))}

                      {!this.state.isExport && (
                        <Td
                          className={`pl-10 pr-10 nowrap ${this.getColor(
                            element.value
                          )}`}
                        >
                          <ButtonIcon
                            className={"blue"}
                            onClick={() =>
                              this.setState({
                                isModalData: true,
                                modalDataIdx: idx,
                              })
                            }
                            small
                          >
                            <FontAwesomeIcon icon={faSearch} />
                          </ButtonIcon>
                          {this.context.role === 1 ||
                          this.context.role === 2 ||
                          this.context.role === 4 ? (
                            <ButtonIcon
                              className={"blue"}
                              onClick={() =>
                                this.setState({
                                  isModalAnalyse: true,
                                  modalAnalyseIdx: idx,
                                })
                              }
                              small
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </ButtonIcon>
                          ) : null}
                        </Td>
                      )}
                    </Tr>
                  )),

                  ...(this.state.isExport
                    ? [
                        (() => {
                          const averages = this.calculateAverages();
                          console.log(
                            "Export state:",
                            this.state.isExport,
                            "Averages:",
                            averages
                          ); // Debug log
                          return averages ? (
                            <Tr
                              key="averages"
                              style={{
                                backgroundColor: "#f0f0f0",
                                fontWeight: "bold",
                              }}
                            >
                              {[
                                ...tableHead,
                                ...dataResp.map((el) => ({
                                  ...el,
                                  isExport: true,
                                })),
                              ].map((elementBody, idxBody) => (
                                <Td
                                  style={
                                    elementBody.minWidth
                                      ? { minWidth: elementBody.minWidth }
                                      : {}
                                  }
                                  className={`pl-10 pr-10 ${
                                    elementBody.isMultiLine ? "" : "nowrap"
                                  }`}
                                  key={`averages-${idxBody}-${
                                    elementBody.key || idxBody
                                  }`}
                                >
                                  {elementBody.isExport
                                    ? averages.data[elementBody.key] !== null
                                      ? getValue(averages.data[elementBody.key])
                                      : ""
                                    : averages[elementBody.key] || ""}
                                </Td>
                              ))}
                            </Tr>
                          ) : null;
                        })(),
                      ]
                    : []),
                ];
              })()}
              {/* Ligne de moyennes pour l'export CSV */}
            </Tbody>
          </Table>
          {this.props.isAll ? null : (
            <Pagination
              activePage={this.props.activePage}
              itemsCountPerPage={this.props.tabLength}
              totalItemsCount={this.props.total}
              pageRangeDisplayed={4}
              onChange={this.props.handlePageChange.bind(this)}
              firstPageText={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
              lastPageText={<FontAwesomeIcon icon={faAngleDoubleRight} />}
              prevPageText={<FontAwesomeIcon icon={faChevronLeft} />}
              nextPageText={<FontAwesomeIcon icon={faChevronRight} />}
            />
          )}
        </Card>
        <ModalDetails
          show={this.state.isModalData}
          onClose={() =>
            this.setState({
              isModalData: false,
              modalDataIdx: null,
            })
          }
          data={
            this.state.modalDataIdx !== null
              ? this.props.listData[this.state.modalDataIdx]
              : {}
          }
        />
        <ModalAnalyse
          show={this.state.isModalAnalyse}
          onClose={() =>
            this.setState({
              isModalAnalyse: false,
              modalAnalyseIdx: null,
            })
          }
          data={this.props.listData}
          idx={this.state.modalAnalyseIdx}
        />
      </>
    );
  }
}
